import React, {useEffect, useRef, useState} from 'react';
import {Box, Button, TableCell, TableRow, Typography} from "@mui/material";
import {
    MenuForPromotion
} from "../../../../../promos/leftMenu/LeftMenuContent/LeftMenuContentElement/MenuForPromotions/menuForPromotions";
import {
    ItemsListMenuDto,
    UserAndPermissionDto, UserDto
} from "../../../../../../../dtos";
import {ReactComponent as MenuOnHover} from "../../../../../../../assets/flyersScreen/3_dots_icon.svg";
import {makeStyles} from "@mui/styles";
import {findUserRole} from "../../../../../../../globals/globFunctions";

const useStyles = makeStyles(() => ({
    tableRow: {
        "& > .MuiTableCell-root": {
            textAlign: "center",
            borderTop: "1px solid #dee2e6",
            padding: 0,
            borderRight: "2px solid #e2e2e2",
            borderBottom: "none"
        },
        '&.onHoverEffect': {
            backgroundColor: "#e4e4e480",
        }
    },
    cellBox: {
        height: `40px`,
        display: `flex`,
        alignItems: `center`,
        // justifyContent: `start`,
        padding: '8px'
    },
    storeMainColor: {
        width: "100%",
        height: "100%",
        borderRadius: "50%"
    }
}))

interface Props {
    userData: UserAndPermissionDto;
    setIsCloseMenu: (value: boolean) => void;
    isCloseMenu: boolean;
    onEdit: (userAndPermissionData: UserAndPermissionDto) => void;
    onDelete: (userAndPermissionData: UserAndPermissionDto) => void;
}

const UserAndPermissionRow: React.FC<Props> = ({
                                                   userData,
                                                   setIsCloseMenu,
                                                   isCloseMenu,
                                                   onEdit,
                                                   onDelete,
                                               }) => {
    const anchorRefForMenu = useRef(null);
    const [isHoverOnRow, changeStatusForHoverOnRow] = useState<boolean>(false);
    const [isOpenedMenu, setOpenMenu] = useState(false);
    const prevOpenMenu = useRef(isOpenedMenu);
    const classes = useStyles();
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr || "");

    useEffect(() => {
        setIsCloseMenu(!isOpenedMenu);
    }, [isOpenedMenu]);

    useEffect(() => {
        if (isCloseMenu && isOpenedMenu) {
            setOpenMenu(!isOpenedMenu);
        }
    }, [isCloseMenu]);

    const onDeleteUserAndPermission = () => {
        // if (props.dto.isDeleteable) {
        onDelete(userData);
        onMouseLeaveRow();
        // }
    }
    const onEditUserAndPermission = () => {
        onEdit(userData);
        onMouseLeaveRow()
    }

    const onSendEmailToUser = () => {

    }

    const onMouseEnterRow = () => {
        changeStatusForHoverOnRow(true);
    }

    const onMouseLeaveRow = () => {
        changeStatusForHoverOnRow(false);
        setOpenMenu(false);
    }

    const handleToggleForFlyer = () => {
        setOpenMenu((prevOpen) => !prevOpen);
    };

    const clickMenuDataForFlyer: ItemsListMenuDto = {
        setOpen: setOpenMenu,
        prevOpen: prevOpenMenu,
        open: isOpenedMenu,
        anchorRef: anchorRefForMenu,
    };


    return (
        <TableRow
            className={`${isHoverOnRow ? "onHoverEffect" : ""} ${classes.tableRow}`} key={1}
            onMouseEnter={onMouseEnterRow}
            onMouseLeave={onMouseLeaveRow}
        >
            <TableCell>
                <Box className={classes.cellBox}>
                    <Typography sx={{
                        wordBreak: "break-all"
                    }}>
                        {userData.acuFirstName}
                    </Typography>
                </Box>
            </TableCell>
            <TableCell>
                <Box className={classes.cellBox}>
                    <Typography sx={{
                        wordBreak: "break-all"
                    }}>
                        {userData.acuLastName}
                    </Typography>
                </Box>
            </TableCell>
            <TableCell>
                <Box className={classes.cellBox}>
                    <Typography sx={{
                        wordBreak: "break-all"
                    }}>
                        {findUserRole(userData.acuRole || 1)}
                    </Typography>
                </Box>
            </TableCell>
            <TableCell>
                <Box className={classes.cellBox}>
                    <Typography sx={{
                        wordBreak: "break-all"
                    }}>
                        {userData.acuEmailAddress}
                    </Typography>
                </Box>
            </TableCell>
            <TableCell>
                {isHoverOnRow &&
                    <Box
                        className={`${classes.cellBox}`}
                        justifyContent={"center"}
                    >
                        <Button
                            sx={{
                                width: "24px",
                                height: "24px",
                                "&:hover": {
                                    backgroundColor: "#88888833"
                                }
                            }}
                            ref={anchorRefForMenu}
                            aria-controls={
                                isOpenedMenu
                                    ? "menu-list-grow"
                                    : undefined
                            }
                            aria-haspopup="true"
                            onClick={handleToggleForFlyer}
                        >
                            <MenuOnHover style={{pointerEvents: "none"}}/>
                        </Button>
                        <MenuForPromotion
                            list={clickMenuDataForFlyer}
                            isDisableDelete={userDto && userDto.emailAddress === userData.acuEmailAddress}
                            deleteUserAndPermission={onDeleteUserAndPermission}
                            // handleDeleteClick={userDto.accountTier === 1 ? handleDeleteClick : softDeleteFlyer}
                            editUserAndPermission={onEditUserAndPermission}
                            infoForMenu={`menuForUserAndPermission`}
                            onSendEmailToUser={onSendEmailToUser}
                            // isDisableDelete={!props.dto.isDeleteable}
                        />
                    </Box>
                }
            </TableCell>
        </TableRow>

    )
}

export default UserAndPermissionRow;